import React from "react"
import differenceInMonths from "date-fns/differenceInMonths"

const MONTH_DISTANCE = 3

export const useBanner = name => {
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    const lastBannerDateStr = window.localStorage.getItem(
      name ? `gatsby:${name}-last-banner-date` : `gatsby:last-banner-date`
    )

    if (!lastBannerDateStr) {
      setIsVisible(true)
    } else if (lastBannerDateStr) {
      const lastBannerDate = Number(lastBannerDateStr)
      const monthDifference = differenceInMonths(Date.now(), lastBannerDate)

      if (monthDifference >= MONTH_DISTANCE) {
        setIsVisible(true)
      }
    }
  }, [])

  const hideBanner = () => {
    setIsVisible(false)
    window &&
      window.localStorage.setItem(
        name ? `gatsby:${name}-last-banner-date` : `gatsby:last-banner-date`,
        Date.now()
      )
  }

  return { isVisible, hideBanner }
}
